import React, { useMemo } from 'react'

import { Icon, Tooltip } from '@fourthwall/components'
import { QuestionMarkIcon } from '@fourthwall/icons'

import type { Product } from '../../../../../../../../../__models__'
import { ExplanationText } from '../../../../../../components/ExplanationText/ExplanationText'
import { getEstimatedProductionTime } from './getEstimatedProductionTime'

type OnDemandListingProps = {
  product: Product
}
export const OnDemandListing = ({ product }: OnDemandListingProps) => {
  const { from, to } = useMemo(() => getEstimatedProductionTime(product), [product])
  const PRODUCTION_TIME_TEXT = from === to ? from : `${from}-${to}`

  if (product.signature) {
    return (
      <ExplanationText
        title="Signature on demand"
        subtitle={
          <>
            This product is produced to order with Signature quality{' '}
            <Tooltip reference={<Icon component={QuestionMarkIcon} height={12} />}>
              Vibrant prints and premium fabrics. Exclusively on Fourthwall.
            </Tooltip>
            . Orders ship within 3-5 days of being placed.
          </>
        }
      />
    )
  }

  return (
    <ExplanationText
      title="On demand"
      subtitle={`This product is produced to order. Orders ship within ${PRODUCTION_TIME_TEXT} days of being placed.`}
    />
  )
}
